import React, { useState } from "react";
import { isEmpty, size } from "lodash";
import { useParams } from "react-router-dom";
import FileUploading from "../files-uploading/FilesUploading";
import { useSelector, useDispatch } from "react-redux";

import { clearUploadFilesState } from "../../../redux/upload-files/uploadFiles.action.js";
import {
  cancelUploadingFiles,
  retryUploadErrors,
} from "../../../services/uploadImages.service.js";
import {
  createInvitesPromise,
  getAllInvitesInCollection,
} from "../../../services/invites.service.js";

import CollectionHeaderPartner from "../collection-header-partner/CollectionHeaderPartner";
import { SECTION_INVITES_COMPONENTS } from "../../../utils/constant";
import { toast } from "react-toastify";
import { STD_ERROR_MESSAGE } from "../../../utils/constant";

const InviteFilesUploading = (props) => {
  const uploadFilesState = useSelector((state) => state.uploadFiles);
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const params = useParams();

  function handleUploadImageStatusCount(statusRole) {
    if (
      size(uploadFilesState.fileProgress) ===
      size(uploadFilesState.uploadSuccess.ids) +
        size(uploadFilesState.uploadError.ids)
    ) {
      if (statusRole === "success") {
        return `Successful Uploads: ${size(
          uploadFilesState.uploadSuccess.ids
        )}`;
      } else {
        if (size(uploadFilesState.uploadError.ids) > 0) {
          return `Errors: ${size(uploadFilesState.uploadError.ids)}`;
        } else {
          return "";
        }
      }
    } else {
      return "";
    }
  }

  function isUploadProgressing() {
    return (
      size(uploadFilesState.fileProgress) >
      size(uploadFilesState.uploadSuccess.ids) +
        size(uploadFilesState.uploadError.ids)
    );
  }

  function handleRetryBtnEvent() {
    dispatch(retryUploadErrors());
  }

  function uploadHasErrors() {
    return size(uploadFilesState.uploadError.ids) > 0;
  }

  function handleProceedBtnEvent() {
    if (!submitting) {
      setSubmitting(true);
      if (size(uploadFilesState.uploadSuccess.ids)) {
        const invitesRequest = [];
        for (const id of uploadFilesState.uploadSuccess.ids) {
          const fileData = uploadFilesState.fileProgress[id];
          invitesRequest.push({
            image_id: fileData.imageId,
            sequence: fileData.id,
          });
        }
        createInvitesPromise(params.collectionId, {
          invite_request: invitesRequest,
        })
          .then((res) => {
            setSubmitting(false);
            dispatch(getAllInvitesInCollection(params.collectionId));
            props.setCurrentMainComponent((prevState) => {
              return {
                currComponent: SECTION_INVITES_COMPONENTS.invites_list,
                prevComponent: prevState.currComponent,
              };
            });
            dispatch(clearUploadFilesState());
          })
          .catch((err) => {
            setSubmitting(false);
            toast.error(
              !isEmpty(err?.error_data) ? err?.error_data : STD_ERROR_MESSAGE
            );
          });
      } else {
        setSubmitting(false);
        props.setCurrentMainComponent((prevState) => {
          return {
            currComponent: SECTION_INVITES_COMPONENTS.invites_list,
            prevComponent: prevState.currComponent,
          };
        });
        dispatch(clearUploadFilesState());
      }
    }
  }

  function handleAddPhotosBtnEvent() {
    props.setCurrentMainComponent((prevState) => {
      return {
        currComponent: SECTION_INVITES_COMPONENTS.upload_invites,
        prevComponent: prevState.currComponent,
      };
    });
  }

  function handleCancelBtnEvent() {
    dispatch(cancelUploadingFiles());
    props.setCurrentMainComponent((prevState) => {
      return {
        currComponent: SECTION_INVITES_COMPONENTS.invites_list,
        prevComponent: prevState.currComponent,
      };
    });
  }

  return (
    <main
      style={{ maxWidth: "850px", marginLeft: "auto", marginRight: "auto" }}
    >
      <CollectionHeaderPartner
        title={`Adding Photos to Invites`}
        uploadSuccessContent={handleUploadImageStatusCount("success")}
        uploadErrorContent={handleUploadImageStatusCount("failure")}
        cancelBtn={isUploadProgressing()}
        handleCancelBtnClick={handleCancelBtnEvent}
        retryBtn={!isUploadProgressing() && uploadHasErrors()}
        handleRetryBtnClick={handleRetryBtnEvent}
        addPhotosBtn={!isUploadProgressing()}
        addPhotosLabel="Add More"
        handleAddPhotosBtn={handleAddPhotosBtnEvent}
        loadingBtn={!isUploadProgressing()}
        loadingBtnProps={{
          loading: submitting,
          onClick: handleProceedBtnEvent,
        }}
        loadingBtnLabel="Proceed"
      />
      <FileUploading />
    </main>
  );
};

export default InviteFilesUploading;
